<template>
  <div v-show="visible">
    <label>Registered plan documents</label>
    <div class="radio radio-primary">
      <input type="radio" :value="false" name="is_using_online_portal" :checked="!isUsingOnlinePortal" />
      <label>I want to complete my registered documents when I sign my subscription documents</label>
    </div>
    <div class="radio radio-primary">
      <input type="radio" :value="true" name="is_using_online_portal" :checked="!!isUsingOnlinePortal" />
      <label>I will use {{ trustee }} online portal</label>
    </div>
  </div>
</template>

<script>

export default {
  props : {
    registeredDefaults: { type: Object }
  },
  data() {
    return {
      visible: false,
      trustee: this.registeredDefaults.trustee,
      isUsingOnlinePortal: this.registeredDefaults.isUsingOnlinePortal,
      optionSelected: '',
    }
  },
  created() {
    this.visible = this.trustee !== ''
    this.$root.$on('accountOptionChanged', this.accountOptionChanged);
  },
  methods: {
    accountOptionChanged(option) {
      this.visible = option.trustee !== ''
      this.trustee = option.trustee
    },
  },
}
</script>